import * as React from "react";

export const Step3 = () => (
  <svg
    width="100%"
    viewBox="0 0 416 266"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ aspectRatio: "416 / 266" }}
  >
    <g clipPath="url(#clip0_6751_165882)" filter="url(#filter0_i_6751_165882)">
      <rect width="416" height="265.778" fill="#F3F4F6" />
      <g filter="url(#filter1_dd_6751_165882)">
        <rect
          x="99.3789"
          y="71.9355"
          width="217.244"
          height="206.556"
          rx="4.62222"
          fill="white"
        />
      </g>
      <rect
        x="106.312"
        y="250.037"
        width="76.2667"
        height="5.77778"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <rect
        x="106.312"
        y="256.971"
        width="66.4444"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="106.312"
        y="263.904"
        width="26.5778"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="106.312"
        y="129.424"
        width="9.82222"
        height="4.04444"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <path
        d="M118.877 133.324L309.979 133.18"
        stroke="#ACB4BD"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="106.312"
        y="164.377"
        width="9.82222"
        height="4.04444"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <path
        d="M118.877 168.277L309.979 168.133"
        stroke="#ACB4BD"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="106.312"
        y="199.336"
        width="9.82222"
        height="4.04444"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <path
        d="M118.877 203.236L309.979 203.092"
        stroke="#ACB4BD"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="106.312"
        y="234.289"
        width="9.82222"
        height="4.04444"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <path
        d="M118.877 238.189L309.979 238.045"
        stroke="#ACB4BD"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="122.49"
        y="186.336"
        width="13.8667"
        height="51.7111"
        fill="#1D4ED8"
      />
      <rect
        x="139.246"
        y="136.936"
        width="13.8667"
        height="101.111"
        fill="#1D4ED8"
      />
      <rect
        x="156.002"
        y="159.758"
        width="13.8667"
        height="78.2889"
        fill="#1D4ED8"
      />
      <rect
        x="172.758"
        y="163.803"
        width="13.8667"
        height="74.2444"
        fill="#1D4ED8"
      />
      <rect
        x="189.512"
        y="170.736"
        width="13.8667"
        height="67.3111"
        fill="#1D4ED8"
      />
      <rect
        x="206.268"
        y="144.736"
        width="13.8667"
        height="93.3111"
        fill="#1D4ED8"
      />
      <rect
        x="223.023"
        y="213.779"
        width="13.8667"
        height="24.2667"
        fill="#1D4ED8"
      />
      <rect
        x="239.779"
        y="196.736"
        width="13.8667"
        height="41.3111"
        fill="#1D4ED8"
      />
      <rect
        x="256.535"
        y="163.803"
        width="13.8667"
        height="74.2444"
        fill="#1D4ED8"
      />
      <rect
        x="273.291"
        y="136.936"
        width="13.8667"
        height="101.111"
        fill="#1D4ED8"
      />
      <rect
        x="290.045"
        y="191.246"
        width="13.8667"
        height="46.8"
        fill="#1D4ED8"
      />
      <rect
        x="106.312"
        y="114.691"
        width="24.8444"
        height="5.77778"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <rect
        x="106.312"
        y="81.1816"
        width="187.778"
        height="6.93333"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <rect
        x="106.312"
        y="90.4258"
        width="125.956"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="106.312"
        y="97.3594"
        width="105.156"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip1_6751_165882)">
        <rect
          x="99.377"
          y="44.2031"
          width="217.244"
          height="23.1111"
          rx="1.15556"
          fill="#D1FAE5"
        />
        <rect
          x="123.645"
          y="49.6914"
          width="184.311"
          height="5.77778"
          rx="0.577778"
          fill="#047857"
        />
        <rect
          x="123.645"
          y="56.625"
          width="153.874"
          height="5.77778"
          rx="0.577778"
          fill="#047857"
        />
        <g clipPath="url(#clip2_6751_165882)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M112.786 48.541L115.556 51.3102V58.9554C116.855 59.0994 117.866 60.2014 117.866 61.5395C117.864 62.9747 116.701 64.1379 115.266 64.1395C114.365 64.1395 113.571 63.6814 113.105 62.9855H104V48.541H112.786ZM114.978 58.9552C113.678 59.0985 112.666 60.2008 112.666 61.5395C112.666 61.8441 112.718 62.1364 112.815 62.408H104.578V49.1191H112.377V51.717H114.978V58.9552ZM112.955 51.1392V49.5265L114.567 51.1392H112.955ZM113.727 61.7588L113.994 61.4629L114.84 62.2221L116.505 60.2871L116.808 60.5462L114.877 62.7908L113.727 61.7588ZM107.179 58.6474V56.9141H105.445V58.6474H107.179ZM106.023 57.4922H106.601V58.07H106.023V57.4922ZM114.112 58.6467V55.7578H112.379V58.6467H114.112ZM112.957 56.3359H113.535V58.0693H112.957V56.3359ZM111.802 58.645V52.8672H110.068V58.645H111.802ZM110.646 53.4453H111.224V58.0675H110.646V53.4453ZM109.489 58.648V54.6035H107.756V58.648H109.489ZM108.334 55.1816H108.912V58.0705H108.334V55.1816Z"
            fill="#047857"
          />
        </g>
      </g>
      <g clipPath="url(#clip3_6751_165882)">
        <rect y="11.5586" width="416" height="27.7333" fill="white" />
        <g clipPath="url(#clip4_6751_165882)">
          <rect y="11.5586" width="416" height="27.7333" fill="white" />
        </g>
        <path
          d="M15.5853 20.6593C15.5853 20.6593 13.9707 19.9355 11.2676 19.9355H11.2667C8.56334 19.9355 6.94846 20.6593 6.94846 20.6593C6.94846 20.6593 6.80384 23.8642 7.41669 25.6764C8.4992 28.8628 11.2662 29.7578 11.2662 29.7578H11.267H11.2679C11.2679 29.7578 14.0343 28.8628 15.1174 25.6764C15.7302 23.8642 15.5853 20.6593 15.5853 20.6593Z"
          fill="#D8232A"
        />
        <path
          d="M14.1567 23.4027V25.1362H12.1345V27.1586H10.4011V25.1362H8.37891V23.4027H10.4011V21.3809H12.1342L12.1345 23.4027H14.1567Z"
          fill="white"
        />
      </g>
      <g
        clipPath="url(#clip5_6751_165882)"
        filter="url(#filter2_i_6751_165882)"
      >
        <rect y="11.5586" width="416" height="27.7333" fill="white" />
        <g clipPath="url(#clip6_6751_165882)">
          <rect y="11.5586" width="416" height="27.7333" fill="white" />
        </g>
        <path
          d="M15.5853 20.6593C15.5853 20.6593 13.9707 19.9355 11.2676 19.9355H11.2667C8.56334 19.9355 6.94846 20.6593 6.94846 20.6593C6.94846 20.6593 6.80384 23.8642 7.41669 25.6764C8.4992 28.8628 11.2662 29.7578 11.2662 29.7578H11.267H11.2679C11.2679 29.7578 14.0343 28.8628 15.1174 25.6764C15.7302 23.8642 15.5853 20.6593 15.5853 20.6593Z"
          fill="#D8232A"
        />
        <path
          d="M14.1567 23.4027V25.1362H12.1345V27.1586H10.4011V25.1362H8.37891V23.4027H10.4011V21.3809H12.1342L12.1345 23.4027H14.1567Z"
          fill="white"
        />
      </g>
      <rect y="0.00390625" width="416" height="11.5556" fill="#2F4356" />
      <circle cx="8.95582" cy="5.78199" r="2.02222" fill="#D8232A" />
      <circle cx="15.3113" cy="5.78199" r="2.02222" fill="#F7B500" />
      <circle cx="21.6668" cy="5.78199" r="2.02222" fill="#6DD400" />
    </g>
    <defs>
      <filter
        id="filter0_i_6751_165882"
        x="0"
        y="-1"
        width="416"
        height="266.777"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.87451 0 0 0 0 0.894118 0 0 0 0 0.913725 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_6751_165882"
        />
      </filter>
      <filter
        id="filter1_dd_6751_165882"
        x="90.7122"
        y="63.2689"
        width="234.577"
        height="223.888"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.577778" />
        <feGaussianBlur stdDeviation="2.88889" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0509804 0 0 0 0 0.105882 0 0 0 0 0.160784 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6751_165882"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0524685 0 0 0 0 0.106102 0 0 0 0 0.159735 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6751_165882"
          result="effect2_dropShadow_6751_165882"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6751_165882"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_i_6751_165882"
        x="0"
        y="11.5586"
        width="416"
        height="27.7324"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.87451 0 0 0 0 0.894118 0 0 0 0 0.913725 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_6751_165882"
        />
      </filter>
      <clipPath id="clip0_6751_165882">
        <rect width="416" height="265.778" fill="white" />
      </clipPath>
      <clipPath id="clip1_6751_165882">
        <rect
          width="217.244"
          height="23.1111"
          fill="white"
          transform="translate(99.377 44.2031)"
        />
      </clipPath>
      <clipPath id="clip2_6751_165882">
        <rect
          width="18.4889"
          height="18.4889"
          fill="white"
          transform="translate(100.533 46.5137)"
        />
      </clipPath>
      <clipPath id="clip3_6751_165882">
        <rect
          width="416"
          height="27.7333"
          fill="white"
          transform="translate(0 11.5586)"
        />
      </clipPath>
      <clipPath id="clip4_6751_165882">
        <rect
          width="416"
          height="27.7333"
          fill="white"
          transform="translate(0 11.5586)"
        />
      </clipPath>
      <clipPath id="clip5_6751_165882">
        <rect
          width="416"
          height="27.7333"
          fill="white"
          transform="translate(0 11.5586)"
        />
      </clipPath>
      <clipPath id="clip6_6751_165882">
        <rect
          width="416"
          height="27.7333"
          fill="white"
          transform="translate(0 11.5586)"
        />
      </clipPath>
    </defs>
  </svg>
);
